/* eslint-disable camelcase */
import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {css} from '@emotion/core'
import {getTheme, getThemeStyles} from '../util/theme'
import {getLanguageCode} from '../util/locale'

import Layout from '../components/Layout'
import Header from '../components/Header'
import Hero from '../components/Hero'
import Footer from '../components/Footer'

const offLineData = {
    off_line: {
        title: 'Off-line',
        contentBlocks: [
            {
                body:
                    '<p>Oh no! You don&rsquo;t have an Internet connection. You need a connection to use Startpage.com. Please check your network connection and try again.</p>',
                title: 'Off-line',
            },
        ],
    },
    defaultHeaderNavigationLinks: [
        {
            link: 'https://www.startpage.com/search/settings?lang=en',
            order: 0,
            title: 'Settings',
        },
        {
            link: 'https://support.startpage.com/index.php?en/Knowledgebase/List',
            order: 1,
            title: 'Support',
        },
        {
            link: 'https://www.startmail.com/en/startpage/?pk_campaign=startpage',
            order: 2,
            title: 'Mail',
        },
    ],
    footerNavigationLinks: [
        {
            link: '/en/privacy-policy/',
            order: 3,
            title: 'Privacy policy',
        },
        {
            link: '/en/about-us/',
            order: 4,
            title: 'About us',
        },
        {
            link: 'https://www.startpage.com/privacy-please/',
            order: 5,
            title: 'Blog',
        },
        {
            link: 'https://www.startpage.com/privacy-please/press/',
            order: 6,
            title: 'Press',
        },
    ],
    hamburgerMenuNavigationLinks: [
        {
            link: 'https://www.startpage.com/search/settings?lang=en',
            order: 0,
            title: 'Settings',
        },
        {
            link: 'https://support.startpage.com/index.php?en/Knowledgebase/List',
            order: 1,
            title: 'Support',
        },
        {
            link: 'https://www.startmail.com/en/startpage/?pk_campaign=startpage',
            order: 2,
            title: 'Mail',
        },
        {
            link: '/en/privacy-policy/',
            order: 3,
            title: 'Privacy policy',
        },
        {
            link: '/en/about-us/',
            order: 4,
            title: 'About us',
        },
        {
            link: 'https://www.startpage.com/privacy-please/',
            order: 5,
            title: 'Blog',
        },
        {
            link: 'https://www.startpage.com/privacy-please/press/',
            order: 6,
            title: 'Press',
        },
    ],
}

const OffLine = ({languageCode}) => {
    const lang = languageCode || getLanguageCode()

    const {off_line, defaultHeaderNavigationLinks, footerNavigationLinks, hamburgerMenuNavigationLinks} = offLineData

    // Getting around legacy datocms
    const newLinks = footerNavigationLinks.map((link) => {
        const {link: url, title: text, order} = link

        return {url, text, order}
    })

    newLinks.push({
        url: `https://www.startmail.com/${lang === 'de' ? 'de' : 'en'}/startpage/?pk_campaign=startpage`,
        text: 'StartMail',
    })

    const {title: pageTitle, contentBlocks} = off_line

    const [theme, setTheme] = useState('light')
    const [themeStyles, setThemeStyles] = useState({})

    useEffect(() => {
        const theme = getTheme()
        const themeStyles = getThemeStyles()
        setTheme(theme)
        setThemeStyles(themeStyles)
    }, [themeStyles])

    return (
        <Layout
            title={pageTitle}
            description={contentBlocks[0].body}
            lang={lang}
            canonicalPath="/off-line/"
            themeStyles={themeStyles}
            noHeaderFooter
            theme={theme}
        >
            <Header
                title={pageTitle}
                links={defaultHeaderNavigationLinks}
                hamburgerMenuNavigationLinks={hamburgerMenuNavigationLinks}
                theme={theme}
                themeStyles={themeStyles}
            />
            <div
                css={css`
                    height: calc(100vh - 120px);
                    min-height: 600px;
                    background: ${themeStyles.lighterBackgroundColor};
                `}
            >
                <Hero
                    title={contentBlocks[0].title}
                    body={contentBlocks[0].body}
                    imageUrl="https://www.datocms-assets.com/4799/1537274301-about-us-1.svg"
                    themeStyles={themeStyles}
                />
            </div>
            <Footer links={newLinks} theme={theme} themeStyles={themeStyles} languageCode={lang} />
        </Layout>
    )
}

OffLine.propTypes = {
    languageCode: PropTypes.string,
}

export default OffLine
